var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImiLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logos",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 524.41 204.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a1d9f8;}.cls-2{fill:#b1b2b3;}.cls-3{fill:#89b4e1;}.cls-4{fill:#4e4a45;}.cls-5{fill:#00abdb;}.cls-6{fill:#9e0148;}.cls-7{fill:#006192;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 69.45,
    y: 68.03,
    width: 19.84,
    height: 19.84
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 109.13,
    y: 107.72,
    width: 19.84,
    height: 19.84
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 89.29,
    y: 87.87,
    width: 9.92,
    height: 9.92
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 128.98,
    y: 97.8,
    width: 9.92,
    height: 9.92
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 79.37,
    y: 109.13,
    width: 9.92,
    height: 9.92
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 192.38,
    y: 39.69,
    width: 0.75,
    height: 119.06
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 39.69,
    y: 39.69,
    width: 39.69,
    height: 39.69,
    transform: "translate(119.06 119.06) rotate(180)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 119.06,
    y: 39.69,
    width: 39.69,
    height: 39.69,
    transform: "translate(277.8 119.06) rotate(180)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 39.69,
    y: 119.06,
    width: 39.69,
    height: 39.69,
    transform: "translate(119.06 277.8) rotate(180)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 119.06,
    y: 119.06,
    width: 39.69,
    height: 39.69,
    transform: "translate(277.8 277.8) rotate(180)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M226.73,61.62h-2.8v-22h2.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M249.35,39.66v22h-3.83l-8.66-19h-.07v19H234.3v-22h3.95l8.55,18.8h.06V39.66Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M258,55.08v.64c0,3,1.89,3.92,3.68,3.92,2.22,0,3.92-.94,3.92-3.56,0-4.86-9.85-4.31-9.85-10.91,0-3.9,2.77-6,6.45-6,4,0,6.26,1.94,6.08,6.41h-2.92c0-2.4-.73-4-3.37-4a3.06,3.06,0,0,0-3.38,3.22c0,4.84,9.85,4.14,9.85,11.1,0,4.62-3.19,6.11-6.81,6.11-6.48.07-6.48-4.89-6.42-7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M286.27,39.66v2.43H280.5V61.62h-2.8V42.09h-5.78V39.66Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M293.24,61.62h-2.8v-22h2.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M311.76,39.66v2.43H306V61.62h-2.8V42.09h-5.77V39.66Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M315.47,39.66h2.8V53.71c0,4.81,1.46,6,4.1,6s4.11-1.21,4.11-6V39.66h2.8V53.59c0,6.08-2.25,8.48-6.91,8.48s-6.9-2.4-6.9-8.48Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M347.37,39.66v2.43h-5.78V61.62H338.8V42.09H333V39.66Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M358.31,61.62V49.91h5.8V51.2H359.8V55h4.09v1.3H359.8v5.35Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M366.55,49.91H368V57.4c0,2.56.78,3.21,2.19,3.21s2.19-.65,2.19-3.21V49.91h1.49v7.43c0,3.24-1.2,4.52-3.68,4.52s-3.68-1.28-3.68-4.52Zm3-1.38h-1.53V46.84h1.53Zm2.85,0h-1.52V46.84h1.52Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M378.51,56.23v5.39H377V49.91h4a2.64,2.64,0,0,1,2.8,2.92,2.52,2.52,0,0,1-2.14,2.67v0c1.35.21,1.83.66,1.92,3a16.82,16.82,0,0,0,.4,3.07h-1.56c-.42-.81-.32-2.34-.45-3.9a1.55,1.55,0,0,0-1.77-1.49Zm0-1.29h2.24c1.07,0,1.59-.93,1.59-1.95a1.6,1.6,0,0,0-1.58-1.79h-2.25Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M226.52,93.65H223.9v-22h4.53L234,90.12H234l5.59-18.42h4.63v22h-2.8V74.13h-.06l-6.15,19.52H232.6l-6-19.52h-.06Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M252.33,93.65v-22h11.32v2.43h-8.52v7.05H263v2.44h-7.91v7.6h8.7v2.43Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M269.91,71.7h6.75c2.8,0,4.81,1,5.9,3.34.88,1.86,1,6.24,1,6.93,0,4.69-.42,7.39-1.33,8.85-1.19,1.89-3.41,2.83-7.24,2.83h-5Zm2.8,19.52h2.64c3.9,0,5.32-1.46,5.32-6.57V80.21c0-4.44-1.36-6.08-4.28-6.08h-3.68Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M293.11,93.65h-2.79v-22h2.79Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.18,74.49,301.29,91.22h11.13v2.43H298.71V90.49l10.64-16.3v-.06H299.07V71.7h13.11Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M321.15,93.65h-2.79v-22h2.79Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M344.6,71.7v22h-3.83l-8.67-19H332v19h-2.49v-22h3.95l8.55,18.79h.06V71.7Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M351.87,82.17h6.69v2.34h-6.69Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M226.73,125.69h-2.8v-22h2.8Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M249.35,103.73v22h-3.83l-8.66-19h-.07v19H234.3v-22h3.95l8.55,18.79h.06V103.73Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M256.35,125.69v-22h10.89v2.43h-8.09v7.06h7.66v2.43h-7.66v10Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M270.73,117.66v-7.21c0-4.38,2.25-7.18,6.91-7.18s6.9,2.8,6.9,7.18v7.21c0,6.08-2.25,8.48-6.9,8.48S270.73,123.74,270.73,117.66Zm10.95.12v-7.42c0-4.59-3.16-4.75-4-4.75s-4.05.16-4.05,4.75v7.42c0,4.8,1.4,6,4.05,6S281.68,122.58,281.68,117.78Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M292.75,115.59v10.1H290v-22h7.58c3.89,0,5.26,2.74,5.26,5.47a4.73,4.73,0,0,1-4,5v.06c2.53.4,3.44,1.25,3.59,5.66a33.88,33.88,0,0,0,.76,5.75H300.2c-.79-1.52-.61-4.38-.85-7.3-.21-2.68-2.37-2.8-3.31-2.8Zm0-2.43H297c2,0,3-1.74,3-3.65,0-1.58-.79-3.35-2.95-3.35h-4.23Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.92,125.69H310.3v-22h4.53l5.54,18.43h.06L326,103.73h4.63v22h-2.8V106.16h-.06l-6.15,19.53H319l-6-19.53h-.06Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M342.38,103.73h3.56l7.15,22H350l-1.58-5.23h-8.49l-1.64,5.23h-2.83Zm1.71,2.58H344L340.59,118h7Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M368.32,103.73v2.43h-5.77v19.53h-2.8V106.16H354v-2.43Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M375.29,125.69h-2.8v-22h2.8Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M383,125.69v-22h2.8v9.64h.09l7.67-9.64h3.16l-8,9.91,8.43,12H393.6l-7.7-11.47h-.09v11.47Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M224.93,153.81c0,1.73,0,4.19,2.71,4.19s2.7-2.46,2.7-4.19v-8.36h1.18v9.22c0,3.43-1.8,4.33-3.88,4.33s-3.89-.9-3.89-4.33v-9.22h1.18Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M235.29,158.74V145.45h1.8l5.4,11.67,0,0V145.45h1.18v13.29h-1.79l-5.41-11.8,0,0v11.76Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M248.87,145.45v13.29h-1.18V145.45Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M258.77,145.45h1.14l-3.68,13.29h-1.47l-3.7-13.29h1.25l3.15,11.89h0Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M268.06,145.45v1h-4.84v5h4.62v1h-4.62v5.34h5v1H262V145.45Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M271.93,152.3v6.44h-1.17V145.45h3.66c2.56,0,3.2.85,3.2,3.19,0,1.65-.28,2.76-2.06,3.16v0c1.86.38,2,.61,2,5.35,0,.52.09,1,.13,1.55h-1.13c-.11-.39-.16-2.6-.18-3.31s.37-3.13-2.19-3.13Zm0-1h1.92c1.76,0,2.59-.46,2.59-2.69,0-1.82-.72-2.17-2.1-2.17h-2.41Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M286.2,148.82c0-1.64-.45-2.63-2.25-2.63-1.44,0-2.34.5-2.34,2.06,0,2,1,2,2.51,3.11s3.31,1.53,3.31,4.1c0,2.38-1.22,3.54-3.54,3.54-2.59,0-3.75-1.4-3.64-4h1.22c0,1.48.11,3,2.48,3a2.06,2.06,0,0,0,2.3-2.35c0-1.8-1.2-2.32-3.11-3.5-2.58-1.58-2.69-2.37-2.7-3.7,0-2.3,1.43-3.25,3.6-3.25,2.76,0,3.35,1.71,3.35,3.62Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M291.83,145.45v13.29h-1.18V145.45Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M297.53,146.45h-3.24v-1H302v1h-3.24v12.29h-1.18Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M307.32,145.45l4.14,13.29h-1.23l-1.07-3.5H304l-1.05,3.5h-1.18l4.2-13.29Zm1.52,8.8-2.26-7.51h0l-2.24,7.51Zm-4.28-11.87h1.18v1.86h-1.18Zm2.9,0h1.18v1.86h-1.18Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M314.86,146.45h-3.24v-1h7.66v1H316v12.29h-1.18Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M326.51,148.82c0-1.64-.44-2.63-2.25-2.63-1.43,0-2.33.5-2.33,2.06,0,2,1,2,2.5,3.11s3.31,1.53,3.31,4.1c0,2.38-1.21,3.54-3.53,3.54-2.6,0-3.76-1.4-3.65-4h1.22c0,1.48.11,3,2.48,3a2.06,2.06,0,0,0,2.3-2.35c0-1.8-1.19-2.32-3.11-3.5-2.57-1.58-2.68-2.37-2.7-3.7,0-2.3,1.43-3.25,3.61-3.25,2.76,0,3.35,1.71,3.35,3.62Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M330.53,158.74V145.45h2l3.92,12h0l3.86-12h1.88v13.29h-1.18V146.59h0l-3.9,12.15h-1.37l-4-12.15h0v12.15Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M351.5,145.45v1h-4.83v5h4.61v1h-4.61v5.34h5v1h-6.14V145.45Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M354.23,145.45h3.51c3.72,0,4.18,2.17,4.18,6.7s-.64,6.59-4.66,6.59h-3Zm1.18,12.3h1.43c3.55,0,3.9-1,3.9-6.39,0-3.81-.51-4.91-3.79-4.91h-1.54Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M366.28,145.45v13.29H365.1V145.45Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M376,145.45v1.31l-6,11H376v1h-7.28v-1.31l6.07-11h-5.71v-1Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379.67,145.45v13.29H378.5V145.45Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M383.12,158.74V145.45h1.8l5.39,11.67,0,0V145.45h1.18v13.29h-1.79l-5.41-11.8,0,0v11.76Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M399.42,145.45H405v1h-4.44v5h4.13v1h-4.13v6.33h-1.17Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M408.51,152.3v6.44h-1.18V145.45H411c2.56,0,3.2.85,3.2,3.19,0,1.65-.27,2.76-2.06,3.16v0c1.86.38,2,.61,2,5.35,0,.52.09,1,.13,1.55h-1.12c-.11-.39-.17-2.6-.19-3.31s.37-3.13-2.19-3.13Zm0-1h1.91c1.77,0,2.6-.46,2.6-2.69,0-1.82-.72-2.17-2.1-2.17h-2.41Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M421.5,145.45l4.14,13.29h-1.23l-1.07-3.5h-5.21l-1.05,3.5H415.9l4.2-13.29Zm1.52,8.8-2.26-7.51h0l-2.24,7.51Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M427.88,158.74V145.45h1.81l5.39,11.67,0,0V145.45h1.18v13.29h-1.78l-5.41-11.8,0,0v11.76Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M440.27,158.74V145.45h1.17v6.09h0l4.71-6.09h1.42l-5,6.2,5.11,7.09h-1.47l-4.8-6.81h0v6.81Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M449.67,145.45h5.61v1h-4.44v5H455v1h-4.13v6.33h-1.17Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M458.74,153.81c0,1.73,0,4.19,2.7,4.19s2.71-2.46,2.71-4.19v-8.36h1.18v9.22c0,3.43-1.81,4.33-3.89,4.33s-3.88-.9-3.88-4.33v-9.22h1.18Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M470.11,152.3v6.44h-1.18V145.45h3.66c2.56,0,3.21.85,3.21,3.19,0,1.65-.28,2.76-2.06,3.16v0c1.85.38,2,.61,2,5.35,0,.52.1,1,.13,1.55h-1.12a31.11,31.11,0,0,1-.18-3.31c0-.57.36-3.13-2.19-3.13Zm0-1H472c1.77,0,2.6-.46,2.6-2.69,0-1.82-.72-2.17-2.1-2.17h-2.41Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M480.76,146.45h-3.23v-1h7.65v1h-3.24v12.29h-1.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImiLogo);
export default __webpack_public_path__ + "static/media/imi-logo.9582d1eab7643ad9c51ffce8213400af.svg";
export { ForwardRef as ReactComponent };